import actions from "@iso/redux/user/actions";
import {getUserProfile} from "@api/user";
import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects';

export function* fetchUserMe() {
  const response = yield call(getUserProfile);

  try {
    yield put({
      type: actions.GET_USER_PROFILE_SUCCESS,
      payload: response?.result
    });
  } catch (error) {
    yield put({
      type: actions.GET_USER_PROFILE_ERROR,
      payload: error,
    });
  }
}

export default function* rootSaga() {
  yield all(
    [
      yield takeEvery(actions.GET_USER_PROFILE, fetchUserMe),
    ]
  )
}